import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../../services/api.service';

export default function useArchiveClientAdminUser() {
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Supprime (archive) un administrateur du client.
   * @param {number} clientId - L'identifiant du client
   * @param {number} userId - L'identifiant de l'administrateur
   * @returns {Promise<object[]|null>} Les administrateurs restants, ou null en cas d'erreur
   */
  const archiveAdminUser = async (clientId, userId) => {
    try {
      setIsLoading(true);

      const response = await fleetApi.delete(
        `/super-admin/clients/${clientId}/admin-users/${userId}`
      );

      if (response.status !== 200) {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }

      toast.success(response.data.message);

      return response.data.admin_users;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    archiveAdminUser,
  };
}
